import { render } from "./CreatorsFeaturedItem.vue?vue&type=template&id=db1e4e8c&ts=true"
import script from "./CreatorsFeaturedItem.vue?vue&type=script&lang=ts"
export * from "./CreatorsFeaturedItem.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__